export default __webpack_public_path__ + "static/media/Musholla.5645ee2f.png";